/**
 * 606 Meta5 AI Trading - Internationalization
 */

export const tradingTranslations = {
  ar: {
    // Page titles
    pageTitle: '606 Meta5 AI Trading',
    pageSubtitle: 'بوت التداول الذكي بالذكاء الاصطناعي',
    
    // Tabs
    dashboard: 'لوحة التحكم',
    positions: 'الصفقات',
    history: 'السجل',
    news: 'الأخبار',
    calendar: 'التقويم',
    analytics: 'التحليلات',
    aiLog: 'سجل AI',
    backtest: 'اختبار خلفي',
    settings: 'الإعدادات',
    
    // Dashboard
    balance: 'الرصيد',
    equity: 'حقوق الملكية',
    openPnl: 'الربح/الخسارة المفتوحة',
    todayPnl: 'ربح اليوم',
    livePrices: 'الأسعار الحية',
    openPositions: 'الصفقات المفتوحة',
    recentAILogs: 'أحدث سجلات AI',
    equityCurve: 'منحنى حقوق الملكية',
    
    // Positions
    symbol: 'الرمز',
    type: 'النوع',
    volume: 'الحجم',
    openPrice: 'سعر الفتح',
    currentPrice: 'السعر الحالي',
    stopLoss: 'الخسارة',
    takeProfit: 'الربح',
    profit: 'الربح/الخسارة',
    openTime: 'وقت الفتح',
    closeTime: 'وقت الإغلاق',
    closePrice: 'سعر الإغلاق',
    closedBy: 'أغلق بواسطة',
    closePosition: 'إغلاق',
    noOpenPositions: 'لا توجد صفقات مفتوحة',
    noHistory: 'لا يوجد سجل',
    buy: 'شراء',
    sell: 'بيع',
    
    // News
    refreshNews: 'تحديث الأخبار',
    runAISentiment: 'تحليل المشاعر بـ AI',
    highImpact: 'تأثير عالي',
    mediumImpact: 'تأثير متوسط',
    lowImpact: 'تأثير منخفض',
    bullish: 'صعودي',
    bearish: 'هبوطي',
    neutral: 'محايد',
    noNews: 'لا توجد أخبار',
    
    // Calendar
    eventTime: 'وقت الحدث',
    forecast: 'التوقع',
    previous: 'السابق',
    actual: 'الفعلي',
    noEvents: 'لا توجد أحداث',
    
    // Analytics
    totalTrades: 'إجمالي الصفقات',
    wins: 'رابحة',
    losses: 'خاسرة',
    winRate: 'نسبة الربح',
    profitFactor: 'عامل الربح',
    maxDrawdown: 'أقصى تراجع',
    avgWin: 'متوسط الربح',
    avgLoss: 'متوسط الخسارة',
    closedPnlToday: 'أرباح اليوم المغلقة',
    totalClosedPnl: 'إجمالي الأرباح المغلقة',
    
    // AI Log
    filterAll: 'الكل',
    filterDecision: 'قرارات',
    filterTrade: 'صفقات',
    filterWarn: 'تحذيرات',
    filterError: 'أخطاء',
    filterInfo: 'معلومات',
    noLogs: 'لا توجد سجلات',
    
    // Backtest
    runBacktest: 'تشغيل الاختبار',
    startBalance: 'الرصيد الابتدائي',
    riskPerTrade: 'المخاطرة لكل صفقة %',
    riskReward: 'نسبة المخاطرة/المكافأة',
    emaFast: 'EMA السريع',
    emaSlow: 'EMA البطيء',
    rsiPeriod: 'فترة RSI',
    rsiOverbought: 'RSI ذروة الشراء',
    rsiOversold: 'RSI ذروة البيع',
    bars: 'عدد الشموع',
    seed: 'البذرة (اختياري)',
    backtestResults: 'نتائج الاختبار',
    endBalance: 'الرصيد النهائي',
    netPnl: 'صافي الربح',
    
    // Settings
    botSettings: 'إعدادات البوت',
    tradingSymbols: 'رموز التداول',
    maxOpenPositions: 'الحد الأقصى للصفقات المفتوحة',
    dailyLossLimit: 'حد الخسارة اليومية %',
    useNewsFilter: 'استخدام فلتر الأخبار',
    useAIConfirmation: 'استخدام تأكيد AI',
    newsBufferMinutes: 'فترة تجنب الأخبار (دقائق)',
    loopInterval: 'فترة الدورة (ثواني)',
    saveSettings: 'حفظ الإعدادات',
    mt5Connection: 'اتصال MT5',
    login: 'رقم الحساب',
    password: 'كلمة المرور',
    server: 'الخادم',
    mode: 'الوضع',
    connect: 'اتصال',
    connected: 'متصل',
    disconnected: 'غير متصل',
    mockMode: 'وضع المحاكاة',
    demoMode: 'وضع تجريبي',
    liveMode: 'وضع حقيقي',
    
    // Trading Mode (where bot executes)
    tradingMode: 'وضع التداول',
    tradingModeMock: 'محاكاة',
    tradingModeMockDesc: 'بدون بروكر — للتجربة',
    tradingModeDemo: 'تجريبي حقيقي',
    tradingModeDemoDesc: 'بروكر حقيقي + حساب تجريبي',
    tradingModeLive: 'حقيقي مباشر',
    tradingModeLiveDesc: 'بروكر حقيقي + حساب حقيقي (أموال فعلية)',
    confirmLiveMode: 'تفعيل وضع الحساب الحقيقي',
    confirmLiveModeWarning: 'تنبيه: سيتم استخدام أموال فعلية في كل صفقة. تأكد من اختياراتك قبل المتابعة.',
    confirmActivate: 'نعم، فعّل',
    cancel: 'إلغاء',
    
    // Extra strategies
    stratBreakout: 'اختراق المستويات',
    stratBreakoutDesc: 'اختراق نطاقات التداول مع تأكيد الزخم',
    stratMeanReversion: 'الارتداد للمتوسط',
    stratMeanReversionDesc: 'شراء عند الانخفاض الزائد / بيع عند الارتفاع الزائد',
    stratTrendFollowing: 'متابعة الاتجاه',
    stratTrendFollowingDesc: 'EMA + MACD لركوب الموجات القوية',
    stratScalping: 'سكالبينج',
    stratScalpingDesc: 'صفقات سريعة على M5 من ارتدادات RSI',
    
    // Bot Control
    startBot: 'تشغيل البوت',
    stopBot: 'إيقاف البوت',
    botRunning: 'البوت يعمل',
    botStopped: 'البوت متوقف',
    cycles: 'الدورات',
    tradesToday: 'صفقات اليوم',
    lastCycle: 'آخر دورة',
    lastError: 'آخر خطأ',
  },
  en: {
    // Page titles
    pageTitle: '606 Meta5 AI Trading',
    pageSubtitle: 'AI-Powered Trading Bot',
    
    // Tabs
    dashboard: 'Dashboard',
    positions: 'Positions',
    history: 'History',
    news: 'News',
    calendar: 'Calendar',
    analytics: 'Analytics',
    aiLog: 'AI Log',
    backtest: 'Backtest',
    settings: 'Settings',
    
    // Dashboard
    balance: 'Balance',
    equity: 'Equity',
    openPnl: 'Open P&L',
    todayPnl: 'Today P&L',
    livePrices: 'Live Prices',
    openPositions: 'Open Positions',
    recentAILogs: 'Recent AI Logs',
    equityCurve: 'Equity Curve',
    
    // ... same pattern for English
    symbol: 'Symbol',
    type: 'Type',
    volume: 'Volume',
    openPrice: 'Open Price',
    currentPrice: 'Current Price',
    stopLoss: 'Loss',
    takeProfit: 'Profit',
    profit: 'P&L',
    openTime: 'Open Time',
    closeTime: 'Close Time',
    closePrice: 'Close Price',
    closedBy: 'Closed By',
    closePosition: 'Close',
    noOpenPositions: 'No open positions',
    noHistory: 'No history',
    buy: 'Buy',
    sell: 'Sell',
    
    refreshNews: 'Refresh News',
    runAISentiment: 'Run AI Sentiment',
    highImpact: 'High Impact',
    mediumImpact: 'Medium Impact',
    lowImpact: 'Low Impact',
    bullish: 'Bullish',
    bearish: 'Bearish',
    neutral: 'Neutral',
    noNews: 'No news',
    
    eventTime: 'Event Time',
    forecast: 'Forecast',
    previous: 'Previous',
    actual: 'Actual',
    noEvents: 'No events',
    
    totalTrades: 'Total Trades',
    wins: 'Wins',
    losses: 'Losses',
    winRate: 'Win Rate',
    profitFactor: 'Profit Factor',
    maxDrawdown: 'Max Drawdown',
    avgWin: 'Avg Win',
    avgLoss: 'Avg Loss',
    closedPnlToday: 'Closed P&L Today',
    totalClosedPnl: 'Total Closed P&L',
    
    filterAll: 'All',
    filterDecision: 'Decisions',
    filterTrade: 'Trades',
    filterWarn: 'Warnings',
    filterError: 'Errors',
    filterInfo: 'Info',
    noLogs: 'No logs',
    
    runBacktest: 'Run Backtest',
    startBalance: 'Start Balance',
    riskPerTrade: 'Risk Per Trade %',
    riskReward: 'Risk/Reward Ratio',
    emaFast: 'EMA Fast',
    emaSlow: 'EMA Slow',
    rsiPeriod: 'RSI Period',
    rsiOverbought: 'RSI Overbought',
    rsiOversold: 'RSI Oversold',
    bars: 'Number of Bars',
    seed: 'Seed (optional)',
    backtestResults: 'Backtest Results',
    endBalance: 'End Balance',
    netPnl: 'Net P&L',
    
    botSettings: 'Bot Settings',
    tradingSymbols: 'Trading Symbols',
    maxOpenPositions: 'Max Open Positions',
    dailyLossLimit: 'Daily Loss Limit %',
    monthlyLossLimit: 'Monthly Loss Limit %',
    monthlyBudget: 'Monthly Risk Budget',
    monthlyPnl: 'Month P&L',
    monthlyUsed: 'used',
    botAutoStopped: 'Bot auto-stopped — monthly risk budget exceeded',
    restartBotManually: 'Manual Restart',
    perStrategyAnalysis: 'Per-Strategy Performance',
    strategyColumn: 'Strategy',
    trades: 'Trades',
    netPnlCol: 'Net P&L',
    noStrategyData: 'No strategy data yet',
    useNewsFilter: 'Use News Filter',
    useAIConfirmation: 'Use AI Confirmation',
    newsBufferMinutes: 'News Buffer (minutes)',
    loopInterval: 'Loop Interval (seconds)',
    saveSettings: 'Save Settings',
    mt5Connection: 'MT5 Connection',
    login: 'Account',
    password: 'Password',
    server: 'Server',
    mode: 'Mode',
    connect: 'Connect',
    connected: 'Connected',
    disconnected: 'Disconnected',
    mockMode: 'Mock Mode',
    demoMode: 'Demo Mode',
    liveMode: 'Live Mode',
    
    tradingMode: 'Trading Mode',
    tradingModeMock: 'Mock',
    tradingModeMockDesc: 'No broker — practice mode',
    tradingModeDemo: 'Demo',
    tradingModeDemoDesc: 'Real broker + demo account',
    tradingModeLive: 'Live',
    tradingModeLiveDesc: 'Real broker + live account (real money)',
    confirmLiveMode: 'Activate Live Account Mode',
    confirmLiveModeWarning: 'Warning: Real funds will be used in every trade. Confirm your choices before continuing.',
    confirmActivate: 'Yes, Activate',
    cancel: 'Cancel',
    
    stratBreakout: 'Breakout',
    stratBreakoutDesc: 'Range breakouts with momentum confirmation',
    stratMeanReversion: 'Mean Reversion',
    stratMeanReversionDesc: 'Buy oversold / sell overbought pullbacks',
    stratTrendFollowing: 'Trend Following',
    stratTrendFollowingDesc: 'EMA + MACD to ride strong waves',
    stratScalping: 'Scalping',
    stratScalpingDesc: 'Quick M5 trades from RSI reversals',
    
    startBot: 'Start Bot',
    stopBot: 'Stop Bot',
    botRunning: 'Bot Running',
    botStopped: 'Bot Stopped',
    cycles: 'Cycles',
    tradesToday: 'Trades Today',
    lastCycle: 'Last Cycle',
    lastError: 'Last Error',
  }
};

export const useTrading = (language = 'ar') => {
  return tradingTranslations[language] || tradingTranslations.ar;
};

export default tradingTranslations;
